// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'

import PageView from 'syft-acp-core/components/PageView'
import WorkersDetail from 'syft-acp-core/entities2/WorkersDetail'
import { recordLabel, useWorkerName } from 'syft-acp-core/components/PageTitle'
import { WorkerSubNavigation } from './SubNavigation'

export const EntityWorkers2View = ({ match: { params } }) => {
  const workerName = useWorkerName(Number(params.id))

  return (
    <>
      <WorkerSubNavigation workerID={params.id} />
      <PageView title={[recordLabel('Worker', params.id, workerName)]}>
        <WorkersDetail id={Number(params.id)} />
      </PageView>
    </>
  )
}
